import type { CycleStatus } from '../api/types';

/** Badge tone for an assessment cycle's status — one map for every surface. */
export const CYCLE_STATUS_TONE: Record<CycleStatus, 'neutral' | 'primary' | 'success'> = {
  diagnosed: 'neutral',
  assigned: 'primary',
  retested: 'success',
  closed: 'neutral',
};
